/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Gallery {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Columns as ColumnsModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"
import { graphql } from "gatsby"

const Columns = ({ suptitle, title, subtitle, columns, numberOfColumns }) => {
  return (
    <Section
      suptitle={suptitle}
      title={title}
      subtitle={subtitle}
      containerSize="medium"
    >
      <ColumnsModule
        count={numberOfColumns}
        contents={columns.map(({ text }) => ({
          title: null,
          content: parse(text),
        }))}
      />
    </Section>
  )
}

export default Columns

export const query = graphql`
  fragment ColumnsModuleFragment on ColumnsModule {
    numberOfColumns
    columns {
      text
      type
    }
  }
`
